import { faLock, faUserGear } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import InfiniteScroll from 'react-infinite-scroll-component';
import assignedVia_1 from '../../../assets/images/assignedVia_1.png';
import assignedVia_2 from '../../../assets/images/assignedVia_2.png';
import assignedVia_3 from '../../../assets/images/assignedVia_3.png';
import assignedVia_4 from '../../../assets/images/assignedVia_4.png';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import SortButtons from '../../../../src/components/SortButtons/index';
import { faRetweet, faSpinner } from '@fortawesome/free-solid-svg-icons';
import '../pages/AssignmentsAndActivities/assignments.scss';
import { useNavigate } from 'react-router-dom';

const AssignmentTable = ({
  isAssignment,
  data,
  nextCallback,
  skipValue,
  limit,
  totalCount,
  setAssignmentSortValue,
  filters,
  setFilters,
  folderId,
  courseId,
  moreOption,
  handleSelect,
  isLoading,
  isCurrentPageSelected
}) => {

  let assign = '';
  let assignText = '';
  let assignTooltip = '';
  let circlePathColor = '';
  let assignedViaImg = '';
  let tooltipContent = '';

  const [assignmentSortOrder, setAssignmentSortOrder] = useState(false);
  const navigate = useNavigate();
  const assignmentWidth = isAssignment
    ? folderId === -1 && courseId === -1
      ? '18%'
      : folderId === -1 || courseId === -1
        ? '26%'
        : '38%'
    : folderId === -1 && courseId === -1
      ? '15%'
      : folderId === -1 || courseId === -1
        ? '23%'
        : '35%';

  const assignedViaWidth = '8%';

  const assignmentSort = (e) => {
    let order = 0;
    let sortValue = '';
    const sortId = e.currentTarget.id;
    switch (sortId) {
    case 'sort-assignment':
      sortValue = 'Assignment';
      break;
    case 'sort-questions':
      sortValue = 'Questions';
      break;
    case 'sort-lastModified':
      sortValue = 'Last Modified';
      break;
    case 'sort-last-assigned':
      sortValue = 'Last Assigned Date';
      break;
    case 'sort-folder':
      sortValue = 'Folder Name';
      break;
    case 'sort-course':
      sortValue = 'Course Name';
      break;
    default:
      sortValue = 'Assignment';
    }
    setAssignmentSortOrder(!assignmentSortOrder);
    if (assignmentSortOrder && filters.sortColumn === sortValue)
      order = 1;

    setFilters(prevFilters => ({ ...prevFilters, sortColumn: sortValue, sortDirection: order === 1 ? 'DESC' : 'ASC' }));
    const sortdata = [sortValue, order];
    setAssignmentSortValue(sortdata);
  };

  const getAssignedDetails =(assignedStatus)=>{
    switch (assignedStatus) {
    case 1:
      assign = 'badge assigned';
      assignText = 'Assigned';
      assignTooltip = 'Assigned/Accessible to all assigned students';
      break;
    case 2:
      assign = 'badge no-access';
      assignText = 'Not Accessible';
      assignTooltip = 'Assigned/Not accessible to any assigned students';
      break;
    case 3:
      assign = 'badge partial';
      assignText = 'Partially Assigned';
      assignTooltip = 'Assigned/Accessible to some assigned students';
      break;
    case 4:
      assign = 'badge random';
      assignText = 'Not Assigned';
      assignTooltip = 'Not Assigned to any students';
      break;
    default:
      assign = 'badge random';
      assignText = 'Not Assigned';
      break;
    }
  };

  const getAssignedViaDetails = (assignedVia)=>{
    switch (assignedVia) {
    case 1:
      assignedViaImg = assignedVia_1;
      tooltipContent = 'Castle';
      break;
    case 2:
      assignedViaImg = assignedVia_2;
      tooltipContent = 'Google Classroom';
      break;
    case 3:
      assignedViaImg = assignedVia_3;
      tooltipContent = 'Schoology';
      break;
    case 4:
      assignedViaImg = assignedVia_4;
      tooltipContent = 'Canvas';
      break;
    default:
      assignedViaImg = '';
      tooltipContent = '';
    }
  };
  
  const getAssignedCompletedColorPath = (percentage) =>{
    if (percentage <= 25) {
      circlePathColor = '#f84646';
    } else if (percentage <= 50) {
      circlePathColor = '#ffa800';
    } else if (percentage <= 75) {
      circlePathColor = '#3e98c7';
    } else {
      circlePathColor = '#52c9a5';
    }
  };

  const getColSpan = () => {
    const defaultCount = isAssignment ? 10 : 8;
    const deductions = (courseId > 0 ? 1 : 0) + (isAssignment && folderId > 0 ? 1 : 0);
    return defaultCount - deductions;
  };

  return  (
    <div>
      <InfiniteScroll
        dataLength={data.length}
        next={() => nextCallback(skipValue + limit)}
        hasMore={(totalCount / (skipValue + limit)) > 1}
        scrollableTarget='scrollableDiv'>
        <div id='scrollableDiv' className='assignments-scroll-bar max-h-550 min-h-500 overflow-y'>
          <table className="table assignment-table-list">
            <colgroup>
              <col style={{ width: '3%' }} />
              <col style={{ width: assignmentWidth }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '12%' }} />
              <col style={{ width: '12%' }} />
              <col style={{ width: '16%' }} />

              {isAssignment && folderId === -1 && <col style={{ width: '13%' }} />}
              {isAssignment && courseId === -1 && <col style={{ width: '13%' }} />}
              {!isAssignment && courseId === -1 && <col style={{ width: '11%' }} />}
              {isAssignment && <col style={{ width: assignedViaWidth }} />}

              <col style={{ width: '10%' }} />
            </colgroup>
            <thead>
              <tr>
                <th className='height-unset'>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      value={isCurrentPageSelected}
                      name='allselect'
                      checked={isCurrentPageSelected}
                      onChange={handleSelect}
                      className="form-check-input"
                      id='allSelectChkBox'
                    />
                  </div>
                </th>
                <th id='sort-assignment' className='height-unset cursor-pointer' onClick={(e) => assignmentSort(e)}>
                  <label className='fs-14'>{ isAssignment ? 'Assignment Name' : 'Assessment Name'}</label>
                  <SortButtons
                    selectedSortId={filters.sortColumn}
                    elementSortId={'Assignment'}
                    isAscending={filters.sortDirection == 'ASC'}
                  />
                </th>
                <th id='sort-questions' className="text-center height-unset cursor-pointer" onClick={(e) => assignmentSort(e)}><label className='fs-14'>Questions</label>
                  <SortButtons
                    selectedSortId={filters.sortColumn}
                    elementSortId={'Questions'}
                    isAscending={filters.sortDirection == 'ASC'}
                  />
                </th>
                <th id='sort-lastModified' className="text-center height-unset cursor-pointer" onClick={(e) => assignmentSort(e)}><label className='fs-14'>Last Modified</label>
                  <SortButtons
                    selectedSortId={filters.sortColumn}
                    elementSortId={'Last Modified'}
                    isAscending={filters.sortDirection == 'ASC'}
                  />
                </th>
                <th id='sort-last-assigned' className="text-center height-unset cursor-pointer" onClick={(e) => assignmentSort(e)}><label className='fs-14'>Last Assigned</label>
                  <SortButtons
                    selectedSortId={filters.sortColumn}
                    elementSortId={'Last Assigned Date'}
                    isAscending={filters.sortDirection == 'ASC'}
                  />
                </th>
                <th className='height-unset text-center'><label className='fs-14'>Status</label></th>
                {isAssignment && folderId === -1 && (
                  <th id='sort-folder' className='text-center height-unset cursor-pointer' onClick={(e) => assignmentSort(e)}>
                    <label className='fs-14'>Folder</label>
                    <SortButtons
                      selectedSortId={filters.sortColumn}
                      elementSortId={'Folder Name'}
                      isAscending={filters.sortDirection == 'ASC'}
                    />
                  </th>
                )}
                {courseId === -1 && (
                  <th id='sort-course' className='text-center height-unset cursor-pointer' onClick={(e) => assignmentSort(e)}>
                    <label className='fs-14'>Course</label>
                    <SortButtons
                      selectedSortId={filters.sortColumn}
                      elementSortId={'Course Name'}
                      isAscending={filters.sortDirection == 'ASC'}
                    />
                  </th>
                )}
                {isAssignment &&
                <th className='height-unset fs-14 text-center'>Assigned<br/>Via</th>
                }
                <th className='height-unset'></th>
              </tr>
            </thead>
            <tbody id="list-body">
              {data.map((item, index) => {
                let lastModified = new Intl.DateTimeFormat('en-US', {
                  year: '2-digit',
                  month: '2-digit',
                  day: '2-digit'
                })
                  .format(new Date(item.lastModifiedOn))
                  .split('/')
                  .join('-');
                let lastAssignedDate = item.lastAssignedDate !== null ? new Intl.DateTimeFormat('en-US', {
                  year: '2-digit',
                  month: '2-digit',
                  day: '2-digit'
                })
                  .format(new Date(item.lastAssignedDate))
                  .split('/')
                  .join('-') : '';
                let percentage = 0;
                if (item.assignedCount != 0) {
                  percentage = ((item.completedCount / item.assignedCount) * 100).toFixed(0);
                }
                getAssignedDetails(item.assignedStatus);
                getAssignedCompletedColorPath(percentage);
                if(isAssignment) {
                  getAssignedViaDetails(item.assignedVia);
                }
                return (
                  <tr key={`${item.assignmentId}-assignment-list-${index}`}>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          value=""
                          name={item.assignmentId}
                          checked={item?.isChecked || false}
                          onChange={handleSelect}
                          className="form-check-input"
                          id={`flexCheckDefault${item.assignmentId}`}
                        />
                      </div>
                    </td>
                    <td>                        
                      <div className='w-100'>{item.assignmentName}</div>
                      <div className='align-items-baseline d-flex gap-2'>
                        {item.ownerName?.trim().length > 0 && (
                          <div>
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="tooltip-top" className="custom-tooltip">
                                  Owner of assignment:<br/>
                                  {item.ownerName}
                                </Tooltip>
                              }>
                              <FontAwesomeIcon icon={faUserGear} className='mr-1 text-danger fs-7'/>
                            </OverlayTrigger>
                          </div>
                        )}
                        {item.isRetakeEnabled &&
                        <OverlayTrigger
                          key={`retakeOption-${index}`}
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-retakeOption-${index}`} className="custom-tooltip">Class Retake Report</Tooltip>
                          }>
                          <div className="assignmentOptions cursor-pointer" style={{ backgroundColor: '#dadce0' }} onClick={() => navigate(`${item.assignmentId}/manage_assign/reports/class_retake_report`)}>
                            <FontAwesomeIcon icon={faRetweet} color="#9E5CDF" className='fs-7'/>
                          </div>
                        </OverlayTrigger>
                        }
                        {(item.locked?.length > 0 || item.benchmarkName?.length > 0) && (
                          <div className="locked-data d-flex align-items-center">
                            {item.locked?.length > 0 && <span className='mr-1'><FontAwesomeIcon icon={faLock} /></span>}
                            <div>{item.locked} {item.benchmarkName?.length > 0 ? 'Benchmark - ' + item.benchmarkName : ''} </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="text-center">{item.noOfQuestion}</td>
                    <td className="text-center w-10"><label className='w-90p'>{lastModified}</label></td>
                    <td className="text-center w-10"><label className='w-90p'>{lastAssignedDate}</label></td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Tooltip id="tooltip-top" className="custom-tooltip">
                              {`${percentage}%`}
                            </Tooltip>
                          }>     
                          <div>               
                            <CircularProgressbar
                              value={percentage}
                              text={`${item.completedCount}/${item.assignedCount}`}
                              strokeWidth={12}
                              styles={buildStyles({
                                pathColor: `${circlePathColor}`,
                                textColor: '#525252',
                                trailColor: '#d6d6d6'
                              })}
                              className='h-33'
                            />
                          </div>   
                        </OverlayTrigger>
                        <div className="d-block mr-2">
                          <ReactTooltip
                            id={`status-${index}`}
                            place="right"
                            content={assignTooltip}
                            className="list-tooltip"
                          />
                          <span data-tooltip-id={`status-${index}`} className={`${assign} p-1`}>
                            {assignText}
                          </span>
                        </div>
                      </div>
                    </td>
                    {isAssignment && folderId === -1 && <td><label className='w-110p'>{item.folderName}</label></td>}
                    {courseId === -1 && <td className='text-center'><label className='w-110p'>{item.courseName}</label></td>}
                    {isAssignment &&
                    <td className="text-center">
                      <ReactTooltip
                        id={`icon-${index}`}
                        place="top"
                        content={tooltipContent}
                        className="list-tooltip z-index10"
                      />
                      <img
                        src={assignedViaImg}
                        className="img-fluid h-25p"
                        data-tooltip-id={`icon-${index}`}
                      />
                    </td>
                    }
                    <td>
                      {moreOption(item,index)}
                    </td>
                  </tr>
                );
              })}
              {isLoading &&
                <tr className='border-white'>
                  <td colSpan={getColSpan()} className='text-center fs-4'>
                    <FontAwesomeIcon icon={faSpinner} spin /><span className='ms-2'></span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </InfiniteScroll>
    </div>
  );
};

AssignmentTable.propTypes = {
  isAssignment: PropTypes.bool,
  data: PropTypes.array,
  nextCallback: PropTypes.func,
  skipValue: PropTypes.number,
  limit: PropTypes.number,
  totalCount: PropTypes.number,
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  setAssignmentSortValue: PropTypes.func,
  folderId: PropTypes.number,
  courseId: PropTypes.number,
  moreOption: PropTypes.func,
  handleSelect: PropTypes.func,
  isLoading: PropTypes.bool,
  isCurrentPageSelected: PropTypes.bool
};
  
export default AssignmentTable;
